//
import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import FETCH_DEPOSIT_DETAIL from 'src/graphql/query/depositDetail';

const useQueryDetailDeposit = (depositId: string | undefined ) => {
  const { data = { }, loading } = useQuery(FETCH_DEPOSIT_DETAIL, {
    //variables: { depositId: 'ca485bfd-3cd9-4704-bb3a-8272e9e7fa81' ? parseInt('ca485bfd-3cd9-4704-bb3a-8272e9e7fa81', 10) : 10},
    variables: { depositId: depositId},
    fetchPolicy: "cache-first",
    pollInterval: 20000
  });

  const depositDetail = useMemo(() => {
    const { depositDetail = null } = data
    return depositDetail ? depositDetail : null
  }, [data])

  return { depositDetail, loading }
}

export default useQueryDetailDeposit
